export const VirmanTypes = {
  SHOW_VIRMAN: "SHOW_VIRMAN",
  ADD_VIRMAN: "ADD_VIRMAN",
  UPDATE_VIRMAN: "UPDATE_VIRMAN",
  DELETE_VIRMAN: "DELETE_VIRMAN",
};
